import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { resourceFromAttributes } from "@opentelemetry/resources";
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from "@opentelemetry/semantic-conventions";
import { ATTR_DEPLOYMENT_ENVIRONMENT_NAME } from "@opentelemetry/semantic-conventions/incubating";
import { W3CTraceContextPropagator } from "@opentelemetry/core";
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { name, version } from "../package.json";
import { environment } from "./environments/environment";

if (!environment.production && !environment.tracingEnabled) {
  // eslint-disable-next-line no-console
  console.debug("[tracing] disabled in non-production environment");
} else {

const exporter = new OTLPTraceExporter({
  url: "https://tempo.mangopower.com/v1/traces",
  headers: {
    Authorization: "Basic dGVtcG9fd2ViX2NsaWVudDpRTG8wWGQ4NmZGQnRYaWNUdEZjVg==",
  },
});

const provider = new WebTracerProvider({
  resource: resourceFromAttributes({
    [ATTR_SERVICE_NAME]: name,
    [ATTR_SERVICE_VERSION]: version,
    [ATTR_DEPLOYMENT_ENVIRONMENT_NAME]: environment.name,
  }),
  spanProcessors: [new BatchSpanProcessor(exporter)],
});

provider.register({
  propagator: new W3CTraceContextPropagator(),
});

registerInstrumentations({
  instrumentations: [
    getWebAutoInstrumentations({
      "@opentelemetry/instrumentation-document-load": {},
      "@opentelemetry/instrumentation-user-interaction": {},
      "@opentelemetry/instrumentation-fetch": {
        ignoreUrls: [/clarity\.ms/],
        propagateTraceHeaderCorsUrls: [/mangopower\.com/],
      },
      "@opentelemetry/instrumentation-xml-http-request": {
        ignoreUrls: [/clarity\.ms/],
        propagateTraceHeaderCorsUrls: [/mangopower\.com/],
      },
    }),
  ],
});

}
